import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Separator } from '@/components/ui/Separator';
import { SidebarTrigger } from '@/components/ui/Sidebar';
import { ToolSwitcher } from '@/components/ToolSwitcher/ToolSwitcher';
import { ROUTES } from '@/constants/constants';

const routeLabelKeys: Record<string, string> = {
  [ROUTES.DASHBOARD]: 'Navigation.dashboard',
  [ROUTES.ORGANIZATIONS]: 'Navigation.organizations',
  [ROUTES.COMPANIES]: 'Navigation.companies',
  [ROUTES.RESIDUALS]: 'Navigation.residuals',
  [ROUTES.PLANS]: 'Navigation.plans',
  [ROUTES.SETTINGS]: 'Navigation.settings',
};

export function PageHeader() {
  const location = useLocation();
  const { t } = useTranslation();

  const pageTitle = React.useMemo(() => {
    const path = location.pathname;
    const basePath = path.replace(/^\/cdk\/?/, '') || ROUTES.DASHBOARD;
    const key = routeLabelKeys[basePath];
    if (key) return t(key);
    const segment = basePath.split('/')[0];
    if (segment) return segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
    return t('Sidebar.scale');
  }, [location.pathname, t]);

  return (
    <header className='flex h-16 shrink-0 items-center gap-2 border-b px-4'>
      <SidebarTrigger className='-ml-1' />
      <Separator orientation='vertical' className='mr-2 h-4' />

      <span className='text-sm font-medium'>{pageTitle}</span>

      <div className='flex-1' />

      <div className='flex shrink-0 items-center gap-2'>
        <ToolSwitcher />
      </div>
    </header>
  );
}
